import getConfig from 'next/config'

import { useGetUser as useGetUserLib } from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const useGetUser = () => useGetUserLib(publicRuntimeConfig.WEB_API_URL)
